import { makeStyles } from "@material-ui/core/styles";

/* 
    styling for searchbar
*/

const useStyles = makeStyles(() => ({
  bar: {
    fontSize: "40px",
    width: "100%",
  },
}));

export default useStyles;
